import _ from 'lodash'

export default {
  data() {
    return {
      PGD_paginationDefaults: {
        pageName: 'page',
        perPageName: 'perPage',
        perPageValue: 20
      }
    }
  },
  methods: {
    PGM_setDefaultRoutePageName(val) {
      this.PGD_paginationDefaults.pageName = val
    },
    PGM_setDefaultRoutePerPageName(val) {
      this.PGD_paginationDefaults.perPageName = val
    },
    PGM_setDefaultRoutePerPageValue(val) {
      this.PGD_paginationDefaults.perPageValue = val
    },
    PGM_getRoutePage() {
      return _
        .chain(this.$route)
        .get('query.' + this.PGD_paginationDefaults.pageName, 1)
        .toNumber()
        .value()
    },
    PGM_getRoutePerPage() {
      return _
        .chain(this.$route)
        .get('query.' + this.PGD_paginationDefaults.perPageName, this.PGD_paginationDefaults.perPageValue)
        .toNumber()
        .value()
    },
    // @deprecated - replaced by ::PGM_changeRoutePage
    changeRoutePage(page, pageName = 'page') {
      this.PGM_changeRoutePage(page, pageName)
    },
    // @deprecated - replaced by ::PGM_changeRoutePerPage
    changeRoutePerPage(perPage, perPageName = 'perPage') {
      this.PGM_changeRoutePerPage(perPage, perPageName)
    },
    // @deprecated - replaced by ::PGM_isPageMoreThanOne
    isPageMoreThanOne(total, perPage) {
      return this.PGM_isPageMoreThanOne(total, perPage)
    },
    PGM_changeRoutePage(page, pageName = 'page') {
      let query = Object.assign({}, this.$route.query)

      if (!_.isFinite(page) || page < 1) {
        page = null
      }

      page = page ? _.toString(page) : null

      if (null === page && query[pageName]) {
        delete query[pageName]
      } else {
        query[pageName] = page
      }

      if (_.isEqual(this.$route.query, query)) {
        return
      }

      this.$router.push({
        name   : this.$route.name,
        params : Object.assign({}, this.$route.params),
        query  : Object.assign({}, query),
      })
    },
    PGM_changeRoutePerPage(perPage, perPageName = 'perPage') {
      let query = Object.assign({}, this.$route.query)

      if (!_.isFinite(perPage) || perPage < 1) {
        perPage = null
      }

      perPage = perPage ? _.toString(perPage) : null

      if (null === perPage && query[perPageName]) {
        delete query[perPageName]
      } else {
        query[perPageName] = perPage
      }

      if (_.isEqual(this.$route.query, query)) {
        return
      }

      this.$router.push({
        name   : this.$route.name,
        params : Object.assign({}, this.$route.params),
        query  : Object.assign({}, query),
      })
    },
    PGM_isPageMoreThanOne(total, perPage) {
      return _.ceil(total / perPage) > 1
    }
  }
}
